<script>
import ApiButton from './ApiButton.vue'
import ButtonTopology from './../button-topology.vue'
import ButtonTopologyClone from './../button-topology-clone.vue'
import ButtonTopologyEdit from './../button-topology-edit.vue'
import ButtonTopologyShare from './../button-topology-share.vue'
import ButtonTopologyDelete from './../button-topology-delete.vue'
import FileUploader from './../File/FileUploader.vue'
import FilterCheckbox from './FilterCheckbox.vue'
import FilterClearButton from './FilterClearButton.vue'
import FilterInput from './FilterInput.vue'
import FilterResetButton from './FilterResetButton.vue'
import FilterSelect from './FilterSelect.vue'
import Pagination from './Pagination.vue'
import ProgressBar from './../progress-bar.vue'
import ToggleSwitch from './ToggleSwitch.vue'
import TopologyHorizontalDiagram from './../topology/TopologyHorizontalDiagram.vue'

export default {
  components: {
    ApiButton,
    ButtonTopology,
    ButtonTopologyClone,
    ButtonTopologyEdit,
    ButtonTopologyShare,
    ButtonTopologyDelete,
    FileUploader,
    FilterCheckbox,
    FilterClearButton,
    FilterInput,
    FilterResetButton,
    FilterSelect,
    Pagination,
    ProgressBar,
    ToggleSwitch,
    TopologyHorizontalDiagram
  },

  props: {
    url: {
      type: String,
      required: true
    },

    nested: {
      type: Boolean,
      default: true
    },

    history: {
      type: Boolean,
      default: true
    },

    refresh: {
      type: Boolean,
      default: false
    },

    refreshInterval: {
      type: Number,
      default: 10000
    },

    query: {
      type: String
    }
  },

  data() {
    return {
      acceptHeader: null,
      autoRefresh: this.refresh,
      currentFilters: {},
      currentRefreshInterval: this.refreshInterval,
      handler: null,
      isLoading: true,
      items: null,
      pagination: null
    }
  },

  created() {
    this.acceptHeader = axios.defaults.headers.common['Accept']

    // Decide whether to use DataArraySerializer or JsonApiSerializer on API
    if(this.nested) {
      this.acceptHeader = this.acceptHeader.replace(
        'application/vnd.api+json', 'application/json'
      )
    }

    if(history.pushState && this.history) {
      // Apply querty string changes when push state history navigation occurs
      window.addEventListener('popstate', function() {
        this.refreshFilters()
      }.bind(this))
    }

    if(history.scrollRestoration && this.history) {
      // Do not track scroll position for push state history
      history.scrollRestoration = 'manual';
    }

    this.refreshFilters()

    if(this.autoRefresh) {
      // Activate auto refresh if
      this.startHandler()
    }
  },

  computed: {
    hasValidFilters() {
      let query = this.filters

      return Object.keys(query).length > 0
    },

    defaultFilters() {
      return queryString.parse(this.query)
    },

    filters() {
      return _.omitBy(this.currentFilters,
        function (value, key) {
          return !value || value == '' || this.hasDefaultFilter(key)
        }.bind(this))
    },

    validFilters() {
      return this.filters
    }
  },

  methods: {
    refreshFilters() {
      this.pagination = null
      if(this.history) {
        this.currentFilters = queryString.parse(location.search)
      }
      this.fetchData()
    },

    hasFilter(key) {
      return key in this.currentFilters && this.currentFilters[key] != ''
    },

    getFilter(key) {
      return this.hasDefaultFilter(key) ? this.defaultFilters[key] : this.currentFilters[key]
    },

    hasDefaultFilter(key) {
      return key in this.defaultFilters && this.defaultFilters[key] != ''
    },

    setFilter(value, key, debounce) {
      if(this.hasDefaultFilter(key)) {
        return false
      }

      let newFilter = {}
      newFilter[key] = value

      this.currentFilters = Object.assign({}, this.currentFilters, newFilter)

      this.clearPagination()

      if(debounce) {
        this.waitToFetchData()
      } else {
        this.fetchData()
      }

      return true
    },

    clearFilters(parameters) {
      if(parameters) {
        parameters.forEach(function(key) {
          this.currentFilters[key] = ''
        }.bind(this))
      } else {
        this.currentFilters = {}
      }

      this.clearPagination()
      this.fetchData()
    },

    clearFilter(key) {
      this.currentFilters[key] = ''

      this.clearPagination()
      this.fetchData()
    },

    buildConfig() {
      if(this.pagination && this.pagination.current_page != 1) {
        this.currentFilters = Object.assign({}, this.currentFilters, {
          page: this.pagination.current_page
        })
      } else if (this.pagination || this.currentFilters.page == 1) {
        this.currentFilters.page = ''
      }

      let url = window.location.origin + window.location.pathname
      let stringify = queryString.stringify(this.validFilters)
      url += (stringify ? '?' + stringify : '')

      let allFilters = Object.assign({}, this.validFilters, this.defaultFilters)
      let urlFilters = queryString.parse(location.search)

      if(history.pushState && this.history &&
          !_.isEqual(urlFilters, this.validFilters) &&
          !_.isEqual(urlFilters, allFilters)
      ) {
        // Current url does not match valid filters and
        // Current url does not match all filters (including default)
        history.pushState(this.validFilters, null, url);
      } else if (history.pushState && this.history &&
          !_.isEqual(urlFilters, this.validFilters) &&
          _.isEqual(urlFilters, allFilters)
      ) {
        // Current url does not match valid filters and
        // Current url matches all filters (including default)
        history.replaceState(this.validFilters, null, url);
      }

      return {
        params: allFilters,
        headers: {
          'Accept': this.acceptHeader
        }
      }
    },

    toggleRefresh(value) {
      this.autoRefresh = value

      this.stopHandler()

      if(this.autoRefresh) {
        this.fetchData()
        this.startHandler()
      }
    },

    /*
     * Start the server long polling interval.
     */
    startHandler() {
      this.handler = setInterval(() => {
        this.fetchData()
      }, this.currentRefreshInterval)
    },

    /*
     * Stop the server long polling interval.
     */
    stopHandler() {
      clearInterval(this.handler)
    },

    clearPagination() {
      this.currentFilters.page = ''
      this.pagination = null
    },

    waitToFetchData: _.debounce(function () {
      this.fetchData()
    }, 300),

    fetchData() {
      this.isLoading = true

      axios.get(this.url, this.buildConfig())
        .then((response) => {
          // success callback
          if(response.data.data) {
            this.items = response.data.data
          } else {
            this.items = response.data
          }

          if(response.data.meta != undefined) {
            this.pagination = response.data.meta.pagination
          } else if (response.data.pagination != undefined) {
            this.pagination = response.data.pagination
          } else if (response.data.total != undefined) {
            this.pagination = {
              total: response.data.total,
              per_page: response.data.per_page,
              current_page: response.data.current_page,
              last_page: response.data.last_page,
              from: response.data.from,
              to: response.data.to,
            }
          }

          this.isLoading = false
        })
        .catch((error) => {
          // error callback
          this.isLoading = false
        })
    }
  },
}
</script>
